import Backbone from 'backbone';
import formValidator from 'formValidator';
import customValidationRules from 'customValidationRules';
import ZipCodeModel from 'models/store/client/cart/zip_code';
import locationHelper from 'app/views/store/common/helpers/location_helper';
import { ZIP_SOURCE_TYPE } from 'lib/enums';

export const ZipChangerView = Backbone.View.extend({
	el: '.js-zip-code-form',
	events: {
		submit: 'validateZip',
		'focus .js-zip': 'highLightZip'
	},
	initialize: function(options = {}) {
		this.zip = options.zip;
		this.$input = this.$el.find('.js-zip');
		this.$goButton = this.$el.find('.js-apply-zip-change-button');

		this.listenTo(Backbone, 'zipCode:complete', this.handleExternalZipChange);
		this.listenTo(Backbone, 'zipCode:forceupdate', this.handleZipForceUpdate);

		this.initFormValidator();
	},
	handleZipForceUpdate: function(zip) {
		this.zip = zip;
	},
	highLightZip: function() {
		this.$input.trigger('select');
	},
	validateZip: function(e) {
		e.preventDefault();

		if (!this.$el.valid()) {
			return;
		}

		const zip = this.$input.trigger('blur').val();

		this.$goButton.button('loading');
		this.setZip(zip);
	},
	handleExternalZipChange: function(zip) {
		if (this.zip === zip) {
			// Since the zip exists the cart needs to be updated.
			Backbone.trigger('cart:changed');
			return;
		}
		this.setZip(zip);
	},
	setZip: function(zip) {
		this.$input.val(zip);
		if (this.zip === zip) {
			Backbone.trigger('zipCode:noChange', zip);
			this.$goButton.button('reset');
			return;
		}

		const zipCode = new ZipCodeModel({
			emailId: window.dataLayer.email,
			zipCode: zip,
			zipCodeResolutionType: ZIP_SOURCE_TYPE.CUSTOMER_PROVIDED
		});
		zipCode.save(null, {
			success: (model, response) => {
				if (response.error === 'CART_RESET') {
					return window.location.reload();
				}

				if (response.status === 1) {
					window.dataLayer.zipCodeSet = true;
					window.dataLayer.isRestrictionsUpdateComplete = false;
					window.dataLayer.isEstimatedDeliveryUpdateComplete = false;
					// Note: the order in which events are triggered is critical.
					// zipCode:changed must be triggered before the cart:changed event is triggered.
					Backbone.trigger('zipCode:changed', zip);
					Backbone.trigger('cart:changed', { shippingOptionUpdated: true, isZipChange: true });
					Backbone.trigger('location:changed', response.data);
					Backbone.trigger('customerLocation:changed', response.data);
					locationHelper.saveLocationCookies(response.data);
					this.zip = zip;
				}
				window.BCOM.notifications.render(response.notification.notification, response.notification.notificationType);
				this.$goButton.button('reset');
			},
			error: () => {
				window.BCOM.notifications.render(`There was an error applying zip code ${zip}`, 'danger');
				this.$goButton.button('reset');
			}
		});
	},
	initValidators: function() {
		customValidationRules.add('zip');
	},
	initFormValidator: function() {
		this.initValidators();
		if (this.$el.length) {
			this.validator = formValidator.init({
				el: this.$el,
				validate: {
					rules: {
						zip: {
							required: true,
							'validate-zip': true
						}
					},
					messages: {
						zip: {
							required: 'Please enter a zip code.'
						}
					}
				}
			});
		}
	},
	show: function() {
		if (!this.$el.hasClass('hide')) {
			return;
		}
		this.$el.removeClass('hide');
		this.$input.trigger('select').trigger('focus');
	},
	hide: function() {
		this.$el.addClass('hide');
	},
	toggleForm: function() {
		this.$el.toggleClass('hide');
	}
});
